import { render, staticRenderFns } from "./ModalNCM.vue?vue&type=template&id=fe308970&scoped=true"
import script from "./ModalNCM.vue?vue&type=script&lang=js"
export * from "./ModalNCM.vue?vue&type=script&lang=js"
import style0 from "./ModalNCM.vue?vue&type=style&index=0&id=fe308970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe308970",
  null
  
)

export default component.exports